import { createTheme } from "@mui/material/styles";
import { colorPalettes } from "../hooks/useColorPalette";


export const getTheme = () => {
    const app = process.env.REACT_APP_APPLICATION || 'assay-central';
    const { muiPalette } = colorPalettes.find(p => p.application === app) || colorPalettes[0];
    return createTheme({
        palette: muiPalette,
    });
}
